<div class="row" ngModelGroup="domainScanLoginBasicAuth">
    <div class="offset-sm-8 col-sm-40 d-flex">
        <h3 class="font-weight-300" translate>Basic Auth</h3>
    </div>
    <div class="col-48">
        <div class="form-group row">
            <label class="col-form-label text-bold text-right col-sm-8" [attr.for]="'basic_auth_username'" translate>Username</label>
            <div class="col-sm-40">
                <input type="text"
                       name="basic_auth_username"
                       required
                       [attr.id]="'basic_auth_username'"
                       [value]="login.basic_auth?.username || ''"
                       (input)="updateUsername($event)"
                       class="form-control"/>
            </div>
        </div>
    </div>
    <div class="col-48">
        <div class="form-group row">
            <label class="col-form-label text-bold text-right col-sm-8" [attr.for]="'basic_auth_password'" translate>Password</label>
            <div class="col-sm-40">
                <input type="password"
                       name="basic_auth_password"
                       required
                       [attr.id]="'basic_auth_password'"
                       [value]="login.basic_auth?.password || ''"
                       (input)="updatePassword($event)"
                       class="form-control"/>
            </div>
        </div>
    </div>
    <div class="offset-8 col-sm-40">
        <h3 class="font-weight-300" translate>Hosts</h3>
    </div>
    <div class="col-48">
        <div class="form-group row" *ngFor="let host of login.basic_auth?.hosts; let i = index; trackBy: trackByIndex">
            <label class="col-form-label text-bold text-right col-sm-8" [attr.for]="'host-' + i" translate>Host</label>
            <div class="col-sm-36">
                <input type="text"
                       class="form-control"
                       [value]="login.basic_auth?.hosts?.[i] || ''"
                       (input)="updateHost(i, $event)"
                       [attr.id]="'host-' + i"/>
                <span class="text-danger"
                      *ngIf="!validHostname[i]"
                      translate>
                      Insert a valid host name
                </span>
            </div>
            <div class="col-sm-4 text-right">
                <button type="button"
                        class="btn btn-border-radius btn-secondary"
                        (click)="removeHost(i)">
                    <span class="fas fa-trash-alt"></span>
                </button>
            </div>
        </div>
    </div>
    <div class="offset-8 col-sm-40">
        <button type="button" class="btn btn-border-radius btn-secondary" (click)="addHost()">
            <span class="fas fa-plus" aria-hidden="true"></span>
        </button>
    </div>
    <div class="offset-8 col-sm-40 text-danger" *ngIf="(login.basic_auth?.hosts?.length ?? 0) === 0">
        <p translate>Hosts cannot be empty</p>
    </div>
</div>
